<template>
  <div class="sentence-edit-popover" ref="popover">
    <div class="workspace-area">
      <SearchAndFind
        v-if="showSearch"
        :section="templateSectionCopy"
        :results="searchResults"
        @close="showSearch = false"
        @toggle-search="showSearch = !showSearch"
        @search-section="searchTemplate"
        class="panel-area search"
      />
      <preview
        :preview="$store.state.sentenceEditorPreview"
        class="panel-area preview"
        v-if="$store.state.sentenceEditorPreview && !showSearch && !openPopover"
      />

      <!-- <button @click="templateSectionCopy.setPaths([]);">test</button> -->
    </div>
    <!-- <img @click="close()" class="close-popover" src="@/assets/svg/close.svg"> -->
    <!-- <div v-bar ref="scroll" class="flex-grow-1" style="overflow:scroll;"> -->
    <div class="editor-mode-header d-flex flex-grow-1">
      <button @click="close()" class="btn btn-xs">
        <i class="fa-light fa-times"></i>
      </button>

      <transition name="fade">
        <div ref="errorMsg" v-if="dragAndDropErr" class="text-danger">
          <span v-html="dragAndDropErrMsg"></span>
        </div>
      </transition>

      <span v-if="$store.state.showingTemplateBackupInPreview" class="text-danger">
        {{$t("backup-banner.disabled-template-text")}}
      </span>
      <div class="global-actions">
        <div>
          <button
            v-if="!isDemo"
            @click="showRawHTML = !showRawHTML"
            class="btn btn-xs"
            :tooltip="
              $store.state.showTooltips == true ? (!showRawHTML ? $t('sentence.raw') : $t('sentence.pretty')) : ''
            "
            tooltip-placement="bottom"
          >
            <div v-show="!showRawHTML">
              <i class="fa-light fa-code"></i>
            </div>
            <div v-show="showRawHTML">
              <i class="fa-light fa-code btn-active"></i>
            </div>
          </button>
        </div>
        <toggle-button
          :tooltip="$store.state.showTooltips == true ? $t('sentence.toggle-tooltip') : ''"
          tooltip-placement="bottom"
          class="unlink-toggle"
          :text="$t('sentence.unscope-toggle-label')"
          :onToggleButton="handleUnlink"
          :value="unlinkTemplateSection"
        />
      </div>
    </div>
    <div ref="scroll" class="flex-grow-1 custom-scrollbar content">
      <!-- <div id="scrollingElement" class="content"> -->
      <!-- the 200px added bottom-padding is to temporarily fix the issue where popups go below the screen border -->
      <div class="sentences-window" style="padding: 0px 0px 20px 50px;">
        <sentence-list
          v-if="templateSection"
          :visible-path="[]"
          :active-path="$store.state.activePath"
          :sentence-list="templateSectionCopy.sentences"
          :unlinkTemplateSection="unlinkTemplateSection"
          :showRawHTML="showRawHTML"
          @empty-section="onAddSentence()"
          @start-drag-sentence-group="($event, scenarioGroup) => handleDragSentenceGroup($event, scenarioGroup, that)"
          @drop-sentence-group="($event, scenarioGroup) => handleDropSentenceGroup($event, scenarioGroup, that)"
        />
        <div v-if="templateSection && !$store.state.showingTemplateBackupInPreview" class="add-rule">
          <div class="dropdown-btn">
            <a @click.stop="handleAction($event, 'addSentence' , () => { onAddSentence('Sentence') })">{{ $t("sentence.sentence-btn") }}</a>
            <dropdown left class="dropdown menu-toggle" forceDown>
              <i class="fa-light fa-chevron-down" slot="toggle"></i>
              <a v-if="$store.state.templateSectionBeingEdited.paragraph" class="spacer-btn dropdown-item" @click="handleAction($event, 'addSentence', () => { onAddSentence('NewParagraph') })"
                >+ {{ getSentenceTypePrettyName("NewParagraph") }}
              </a>
              <a class="spacer-btn dropdown-item" @click="handleAction($event, 'addSentence', () => { onAddSentence('Linebreak') })"
                >+ {{ $t("sentence.single-break") }}
              </a>
              <a class="spacer-btn dropdown-item" @click="handleAction($event, 'addSentence', () => { onAddSentence('Sectionbreak') })">
                + {{ $t("sentence.double-break") }}
              </a>
              <a class="spacer-btn dropdown-item" @click="handleAction($event, 'addSentence', () => { onCreateTable() })">
                + {{getSentenceTypePrettyName("Table")}}
              </a>
              <a class="spacer-btn dropdown-item" @click="handleAction($event, 'addSentence', () => { onCreateList('OrderedList') })">
                + {{getSentenceTypePrettyName("OrderedList")}}
              </a>
              <a class="spacer-btn dropdown-item" @click="handleAction($event, 'addSentence', () => { onCreateList('UnorderedList') })">
                + {{getSentenceTypePrettyName("UnorderedList")}}
              </a>
            </dropdown>
          </div>
        </div>

        <div class="ghost-element" :style="{height: ghostHeight + 'px'}"></div>
      </div>
    </div>
    <div class="sentence-edit-button">
      <button
        :disabled="!unsavedChanges"
        @click="saveNQuit(true)"
        class="sentence-edit-button--save"
        v-bind:style="{ color: colorSave }"
      >
        <span>{{ saveText }}</span>
        <i class="fa-light fa-check"></i>
      </button>
      <button class="sentence-edit-button--find" @click="showSearch = !showSearch">
        <span>Find</span>
        <i class="fa-light fa-search"></i>
      </button>
    </div>
  </div>
</template>

<script>
import LeaveEditor from "@/components/modals/LeaveEditor";
import EventBus from "@/assets/js/eventBus.js";
import Preview from "@/components/Preview";
import SearchAndFind from "@/components/SearchAndFind";
import ToggleButton from "@/components/ToggleButton";
import {editorMixin}  from "@/assets/js/editorMixin.js"
import CreateTableModal from "@/components/modals/CreateTableModal";
export default {
  name: "SentenceEditPopover",
  mixins: [editorMixin],
  props: {
    template: {
      type: Object,
      required: true,
    },
    sentence: {
      type: Object,
      required: true,
    },
    sentenceElement: {
      type: HTMLSpanElement,
    },
    // templateSectionId: {
    // 	type: String,
    // 	required: true
    // },
    templateSection: {
      type: Object,
      required: true,
    },
    comparisonView: Boolean,
  },
  data() {
    return {
      templateSectionCopy: null,
      unsavedChanges: false,
      savedChanges: false,
      showWarning: false,
      warningPopupText: null,
      // saveText:this.$t('sentence.save'),
      saveText: this.$t("done"),
      colorSave: "var(--text-grey-primary)",
      saving: false,
      searchResults: [],
      showSearch: false,
      openPopover: false,
      unlinkTemplateSection: false,
      showRawHTML: false,
      that: this,
      dragAndDropErr: false,
      dragAndDropErrMsg: "",
      ghostHeight: 0
    };
  },
  computed: {
    isDemo() {
      return this.$store.state.editorIsDemoVersion
    }
    // position() {
    // 	return this.sentenceElement
    // 			? {top: this.sentenceElement.offsetHeight + this.sentenceElement.offsetTop}
    // 			: {top: 0}asd
    // }
  },
  methods: {
    // handleDragSentenceGroup(evt, scenarioGroup, that){
    // 	console.log(evt)
    // 	console.log(scenarioGroup)
    // 	console.log("dragging", scenarioGroup)
    // 	evt.stopPropagation()
    // 	evt.dataTransfer.dropEffect = 'move'
    // 	evt.dataTransfer.effectAllowed = 'move'

    // 	evt.dataTransfer.setData('draggingSentenceGroup', JSON.stringify(scenarioGroup))

    // 	that.$set(that.$store.state, 'draggedSentenceGroup' ,  scenarioGroup )
    // },
    // handleDropSentenceGroup(evt, scenarioGroup, that){
    // 	console.log(evt)
    // 	console.log(scenarioGroup)
    // 	const draggedSentenceGroup = JSON.parse(evt.dataTransfer.getData('draggingSentenceGroup'))
    // 	console.log(draggedSentenceGroup)
    // },

    handleUnlink() {
      this.unlinkTemplateSection = !this.unlinkTemplateSection;
      // if(this.unlinkTemplateSection){EventBus.$emit('unlink-template')}
      // if(!this.unlinkTemplateSection){EventBus.$emit('relink-template')}
    },
    searchTemplate(searchQuery) {
      this.searchResults = [];
      this.searchResults = this.template.search(searchQuery, this.templateSection);
    },

    saveNQuit(q) {
      // this.showWarning = true
      this.saving = true;
      this.saveChanges(true);
    },
    editSentence() {
      // this.$store.commit('setSentenceBeingEdited', sentence)
      // this.templateSection = this.template[this.templateSectionName].clone()
      // this.templateSection.setPaths([])
      // // console.log('templates', this.templateSection)
      // this.$store.commit('setTemplateSectionBeingEdited', this.templateSection)
      // this.$store.dispatch('setActivePath', this.sentence.path)
      // this.templateSectionName = section
      // this.sentence = sentence
      // this.sentenceElement = element
      // this.unsavedChanges = false
      // this.showWarning = false
      // const preview = this.getPreview()
      // this.$store.commit('setSentenceEditorPreview', preview)
      // setTimeout(function () {
      // 	let highlight = document.querySelector('.highlight')
      // 	if (highlight != null) {
      // 		let closest = highlight.closest('.sentence')
      // 		closest != null ? closest.scrollIntoView() : closest // Keep the highlighted text into view on popup.
      // 	}
      // }, 50)
    },
    onCreateList(sentenceType){
      const list = this.templateSectionCopy.sentences.createListBelow(sentenceType);
      this.$store.dispatch("setActivePath", list.path);
      EventBus.$emit("templateChange");
    },
    onCreateTable(){
        this.$modal.show(
        CreateTableModal,
        {
          onCreate: (columns, rows, applyTableHeadRow, applyTableHeadColumn) => {
            const tableBase = this.templateSectionCopy.sentences.createTableBelow(
              columns,
              rows,
              applyTableHeadRow,
              applyTableHeadColumn
            );
            this.$store.dispatch("setActivePath", tableBase.path);
            EventBus.$emit("templateChange");
          }
        },
        { width: 350, height: "auto", adaptive: true }
      );
    },
    onAddSentence(sentenceType) {
      let sentence = this.templateSectionCopy.sentences.addNewSentence(sentenceType);
      this.$store.dispatch("setActivePath", sentence.path);
      EventBus.$emit("templateChange");
    },
    close(discardChanges) {
      if (this.unsavedChanges && !discardChanges) {
        // if the text is edited
        this.warningPopupText = this.$t("sentence.close-text");
        this.$modal.show(
          LeaveEditor,
          {
            reverse: true,
            title: this.$t("close-section.title"),
            description: this.$t("close-section.description"),
            thirdOption: true,
            thirdOptionText: this.$t("close-section.trash"),
            confirmButtonText: this.$t("close-section.keep"),
            onConfirm: () => {
              this.saveNQuit();
            },
            onThirdOptionClick: () => {
              this.close(true);
              this.warningPopupText = '';
            },
            confirmBtnPrimaryColor: true
          },
          { width: 450, height: "auto", adaptive: true }
        );
      } else {
        // or close the popup editor
        // this.sentence = null
        this.$store.commit("setSentenceBeingEdited", null);
        this.$store.commit("setTemplateSectionBeingEdited", null);
        this.$store.commit("setSentenceEditorPreview", null);
        // // this.templateSection = null
      }
    },
    saveChanges(closeAfter) {
      if (this.unsavedChanges) {
        // get the index of the current section in the template.
        let templateSectionIndex = this.$store.state.template.sections
          .map((s) => s.id)
          .indexOf(this.templateSection.id);
        // replace the section with the edited copy.
        this.$store.state.template.sections[templateSectionIndex] = this.templateSectionCopy;
        // this.saveText =  this.$t('sentence.saving')
        this.colorSave = `var(--orange-web)`;
        // this.showWarning = false
        this.$store.state.unsavedChanges = true;
        this.$store
          .dispatch("getTemplatePreview", {
            template: this.$store.state.template,
            variables: this.$store.state.templateVariables,
          })
          .then((preview) => {
            // this.saveText =  this.$t('sentence.saved')
            this.colorSave = `var(--text-grey-primary)`;
            this.unsavedChanges = false;
            this.savedChanges = true;
            // this.$store.state.templatePreview = preview;
            this.$store.commit("setTemplatePreview", preview);
            if (closeAfter === true) {
              // this.$store.dispatch('saveTemplateChanges').then(() => {
              // 		this.saving = false
              // 	}, () => {
              // 		this.saving = false
              // 		this.savingError = true
              // 	})
              this.showWarning = false;
              this.saving = false;
              this.close(true);
            }
            //trying to make the multi view update all open ones when the section is saved.
            if (this.$store.state.templateMultiplePreview.length > 0) {
              EventBus.$emit("update-multi-view");
            }
            
            if(this.isDemo == true){
              this.$store.dispatch("saveTemplateChanges", true).then(() => {
                // CTA When saving?
              })
            }

            //This should fix the saving issues inside a section. - Making sure when the editted copy is saved and replaced with a new copy
            this.templateSectionCopy.setPaths([]);
            this.$store.commit("setTemplateSectionBeingEdited", this.templateSectionCopy);
          })
          .catch((e) => {
            this.savedChanges = true;
            this.saving = false;
            this.colorSave = "#fff";
          });

        //Error----

        // console.log('clicked save')
      }
    },
    deleteChanges() {
      this.showWarning = true;
      this.warningPopupText = this.$t("sentence.close-text1");
      // console.log('clicked delete')
    },
    getPreview() {
      let previewIsActive = this.$store.state.previewIsActive;
      // template[this.templateSectionName] = this.templateSection // this is where we overwrite the template - whoops!
      return this.$store
        .dispatch("getTemplatePreview", {
          template: this.$store.state.template,
          variables: this.$store.state.templateVariables,
        })
        .then((preview) => {
          this.$store.commit(
            "setSentenceEditorPreview",
            preview.sections.find((s) => s.id === this.templateSection.id).result.sentences,
          );
        });
    },
    onTemplateChange() {
      this.colorSave = "#fff";
      this.unsavedChanges = true;
      // this.saveText =  this.$t('sentence.save')
      // this.saveText =  'Done'
    },

    // handlePopoverStatus(){
    // 	this.openPopover = !this.openPopover
    // 	console.log(this.openPopover)
    // }
  },
  components: {
    Preview,
    SearchAndFind,
    ToggleButton,
  },
  mounted() {
    EventBus.$on("hide-ghost-element", () => {
      this.ghostHeight = 0
    })
    EventBus.$on("trigger-ghost-element", (height) => {
      this.ghostHeight = height
    })
    EventBus.$on("close_preview", () => {
      this.openPopover = true;
    }),
      EventBus.$on("open_preview", () => {
        this.openPopover = false;
      }),
      // EventBus.$on('close_preview', this.handlePopoverStatus)
      // EventBus.$on('open_preview', this.handlePopoverStatus)
      EventBus.$on("close_backup_preview", this.close);
      EventBus.$on("drag-and-drop-err", (msg) => {
        this.dragAndDropErr = true;
        this.dragAndDropErrMsg = msg;
        setTimeout(() => {
          this.dragAndDropErr = false;
        }, 3000);
      });
  },
  created() {
    this.templateSectionCopy = this.templateSection.clone();
    this.templateSectionCopy.setPaths([]);
    this.$store.commit("setTemplateSectionBeingEdited", this.templateSectionCopy);
    this.$store.dispatch("setActivePath", this.sentence.path.slice(0, this.sentence.path.length - 1));
    EventBus.$on("templateChange", this.onTemplateChange);
    // EventBus.$on('variable-change', this.getPreview)
    EventBus.$emit("close_panel");
    EventBus.$emit("lock-databrowser");

    if (this.template.methods.length > 0) {
      //Makes sure that the user can use a new template methods without saving the template.
      this.$store.dispatch("getTemplate", this.$route.params.templateId).then((res) => {
        this.$store.state.template.methods = res.methods;
      });
    }
  },
  destroyed() {
    EventBus.$emit("unlock-databrowser");
    // remove eventbus handlers
    EventBus.$off("templateChange", this.onTemplateChange);
    if (this.comparisonView == false) {
      EventBus.$emit("open_panel");
    } else {
      EventBus.$emit("unlock-panel");
    }
    // EventBus.$off('variable-change', this.getPreview)
    EventBus.$off("close_backup_preview");
    EventBus.$off("trigger-ghost-element");
    EventBus.$off("hide-ghost-element");

  },
};
</script>

<style lang="less">
.ghost-element{
  width: 100%;
  background: inherit;
  min-height: 12px;
}
.workspace-area {
  position: absolute;
  right: 20px;
  background-color: var(--charcoal-115);
  // background-color:  rgb(61, 70, 74);
  border-left: 1px solid var(--charcoal-border);
  width: 300px;
  height: calc(100% - 30px);
  z-index: 99;
  display: flex;
  flex-direction: column;
  // justify-content: flex-end;
  border-radius: 0 10px 10px 0;
  padding-bottom: 10px;

  .preview,
  .search {
    // top: 0;
    // position: absolute;
    margin-top: 12px;
    // width: 300px;
    overflow: auto;
  }
  .search {
    margin-top: 0;
  }
}
.sentence-edit-popover {
  // position: absolute;
  position: fixed;
  background-color: rgba(61, 70, 74, 0.4);
  // top: 0;
  // width: 100%;
  // width: calc(100% - 68px);
  width: calc(100%);
  height: calc(100% - 55px);
  top: 55px;
  padding: 15px;
  padding-right: 320px;
  z-index: 99;
  color: #fff;
  display: flex;
  flex-direction: column;
  // margin-top: 30px;

  * {
    // pointer-events: none;
    tab-size: 0;
  }

  img.close-popover,
  img.error {
    position: absolute;
    z-index: 101;
    right: 0px;
    height: 32px;
    width: 32px;
    cursor: pointer;
  }

  img.close-popover {
    margin-top: -16px;
  }

  img.error {
    margin-top: 22px;
  }
  .content {
    background-color: var(--charcoal);
    // border-radius: 2px 0 0;
    height: 100%;
    overflow: auto;
    position: relative;
    .popup-window {
      // width: 25%;
      height: 100%;
      background-color: #333a3e;
    }
  }

  a {
    color: #fff;
    cursor: pointer;

    &:hover {
      color: var(--text-grey-primary);
      text-decoration: none;
    }
  }

  .sentence-edit-button {
    width: 100%;
    border-top: 1px solid var(--charcoal-border);
    color: #8f979c;
    display: flex;
    // height: 120px;
    img {
      margin-left: 4px;
      height: 14px;
      width: auto;
    }
    svg {
      font-size: 12px;
      margin-left: 4px;
    }
  }
  .sentence-edit-button--find,
  .sentence-edit-button--save {
    width: 50%;
    outline: 0 none;
    color: inherit;
    border: 0 none;
    line-height: 37px;
    height: 37px;
    flex: 1 1 auto;
    margin: 0;
    padding: 0;
    background: #3d464a;
  }

  .sentence-edit-button--find {
    color: #fff;
    &:focus {
      outline: none !important;
    }
    &:hover {
      color: var(--text-grey-primary);
    }
  }

  .sentence-edit-button--save {
    border-right: 1px solid var(--charcoal-border);
    border-radius: 0 0 0 10px;
  }

  .save-warning-popup {
    position: absolute;
    top: 0;
    bottom: 0;
    left: 0;
    right: 0;
    background: rgba(61, 70, 74, 0.9);
  }

  .save-warning-popup--log {
    position: relative;
    background-color: #fff;
    width: max-content;
    // margin-left: 15%;
    top: 50%;
    left: 50%;
    transform: translate(-50%, -50%);
    // text-align: center;
    border-radius: var(--standard-border-radius);
    overflow: hidden;
    padding: 25px 0px 25px 0px;
    z-index: 999;
  }

  .message-wrapper {
    display: flex;
    flex-direction: row;
    padding: 25px;
    padding-top: 0;
    .exclamation {
      font-size: 50px;
      color: var(--flame);
    }
  }

  .btns-wrap {
    margin-left: 30px;
    padding: 0 25px 0 0;
    display: flex;
    justify-content: space-between;
  }

  .save-warning-popup--text {
    color: var(--charcoal-75);
    align-self: center;
    margin-left: 20px;
  }

  .save-warning-button {
    padding: 0 20px;
    line-height: 30px;
    &.btn-cancel {
      margin-right: 15px;
    }
  }
  .add-rule {
    cursor: pointer;
    padding-top: 15px;
    padding-left: 8px;
    .dropdown-btn {
      background: rgba(176, 179, 176, 0.144);
      // background: #333A3E;
      border-radius: 20px;
      padding: 0;
      box-sizing: border-box;
      display: flex;
      width: max-content;
      & > a {
        color: var(--orange-web) !important;
      }
    }
    div {
      padding: 4px 8px;
    }
    a {
      &:hover {
        background: #3a4246;
        border-radius: 20px 0 0 20px;
      }
      padding: 4px 8px;
    }
    .spacer-btn {
      color: #8f979c !important ;
    }

    .dropdown {
      border-left: 1px solid #3d464a;
      border-radius: 0 20px 20px 0;
      &:hover {
        background: #3a4246;
      }
      div {
        background: none;
        border: none;
        .dropdown-item {
          padding: 5px !important;
        }
        a {
          &:hover {
            // background: #3d464a;
            background: rgba(176, 179, 176, 0.144);
          }
        }
      }
    }

    .menu-toggle {
      svg {
        width: 10px;
        cursor: pointer;
        color: var(--orange-web);
      }
    }
  }
  .editor-mode-header {
    background-color: rgb(61, 70, 74);
    border-bottom: 1px solid var(--charcoal-border);
    padding: 10px 0;
    // justify-content: flex-end;
    justify-content: space-between;
    border-radius: 10px 0 0 0;
    .global-actions {
      display: flex;
      flex-direction: row;
      align-items: center;
      gap: 18px;
      button {
        svg {
          margin: 0;
        }
      }
    }
    .btn-active {
      color: var(--orange-web);
    }
    svg {
      color: #fff;
      margin-left: 4px;
    }
  }
  .fade-enter-active,
  .fade-leave-active{
    transition-delay: 0s !important
  }
}
</style>
